var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicBody = void 0;
const react_1 = __importStar(require("react"));
const get_topic_info_1 = require("../../lib/get-topic-info");
const topic_content_1 = require("./topic-content");
const topic_media_1 = require("./topic-media");
exports.TopicBody = (props) => {
    const topicInfo = get_topic_info_1.getTopicInfo(props.topic);
    const topicOptions = props.topicOptions;
    const showMedia = topicInfo.hasMedia && !topicOptions.hideMedia;
    const media = (react_1.default.createElement(topic_media_1.TopicMedia, { data: props.data, topic: props.topic, topicInfo: topicInfo, topicOptions: props.topicOptions, wheel: props.wheel }));
    const content = (react_1.default.createElement(topic_content_1.TopicContent, { data: props.data, fullTopicAsLink: props.fullTopicAsLink, maxActions: props.maxActions, topic: props.topic, topicInfo: topicInfo, topicOptions: props.topicOptions, useIconElement: props.useIconElement, useAbstractElement: props.useAbstractElement, useAbstractParser: props.useAbstractParser, useHeadingElement: props.useHeadingElement, useHeadingParser: props.useHeadingParser, wheel: props.wheel }));
    if (topicOptions.reverseOrder) {
        return (react_1.default.createElement(react_1.Fragment, null,
            content,
            showMedia && media));
    }
    else {
        return (react_1.default.createElement(react_1.Fragment, null,
            showMedia && media,
            content));
    }
};
//# sourceMappingURL=topic-body.js.map